import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

export default class extends Controller {
  static targets = ["item"]
  static values = {
    showValue: String,
    reverse: Boolean
  }

  connect() {
    this.update()
  }

  toggle(event) {
    this.update(event.target.value)
  }

  update(currentValue) {
    const value = currentValue || this.element.querySelector('input:checked, select')?.value
    const isMatch = value === this.showValueValue

    // If reverse is true, we show when it's NOT a match
    const shouldShow = this.reverseValue ? !isMatch : isMatch

    if (shouldShow) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.itemTargets.forEach((item) => {
      if (item.classList.contains('hidden')) {
        enter(item)
      }
    })
  }

  hide() {
    this.itemTargets.forEach((item) => {
      if (!item.classList.contains('hidden')) {
        leave(item)
      }
    })
  }
}